"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combine = exports.axiosSwaLike = exports.axiosRpcLike = void 0;
/**
 * {"status": 200, "body": {...}} => 200
 */
var axiosRpcLike = function (req) {
    if ('request' in req && req.data && 'status' in req.data && 'body' in req.data) {
        return req.data.status;
    }
    return null;
};
exports.axiosRpcLike = axiosRpcLike;
/**
 * {"code_number": 406, ...} => 406
 */
var axiosSwaLike = function (req) {
    if ('request' in req && req.data && 'code_number' in req.data) {
        return req.data.code_number;
    }
    return null;
};
exports.axiosSwaLike = axiosSwaLike;
function combine() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        for (var i = 0; i < fns.length; i++) {
            var result = fns[i].apply(null, params);
            if (result) {
                return result;
            }
        }
        return null;
    };
}
exports.combine = combine;
//# sourceMappingURL=metrics.api.parse-status.js.map